import { useState } from 'react'

export const useCommonUtil = () => {

  const formatPhoneNumber = (phoneNumber: string): string => {
    const cleaned = phoneNumber.replace(/\D/g, '') // 숫자 이외의 문자 제거
    const match = cleaned.match(/^(\d{3})(\d{3,4})(\d{4})$/) // 숫자를 그룹으로 나누기
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}` // 하이픈으로 구분하여 반환
    }
    return phoneNumber // 변환할 수 없는 경우 원래 값 반환
  }

  function getNextDayIfPast(inputDate: Date): Date {
  const currentDate = new Date();

  // 1. 비교 대상 생성 (시간을 00:00:00으로 맞춰서 날짜만 비교하게 함)
  const comparisonDate = new Date(inputDate);
  
  if (inputDate < currentDate) {
    // 과거라면 오늘 기준 내일 00:00:00 리턴
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    return new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate());
  }

  // 2. 미래라면 해당 날짜의 00:00:00 리턴
  return new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
}

  const formatDate = (birthday: string): string => {
    const year = birthday.slice(0, 2)
    const month = birthday.slice(2, 4)
    const day = birthday.slice(4, 6)

    const currentYear = new Date().getFullYear()
    const fullYear =
      parseInt(year) + (parseInt(year) >= currentYear % 100 ? 1900 : 2000) // 1900년과 2000년도 구분

    return `${fullYear}-${month}-${day}`
  }

  // 날짜를 "yyyy-MM-dd HH:mm" 형식으로 변환하는 함수
  function formatDate2(dateString: string): string {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  // 현재 시간과 지정된 날짜를 비교하는 함수
  function compareWithCurrentTime(targetDateString: string) {
    const targetDate = new Date(targetDateString)
    const currentDate = new Date()

    if (targetDate < currentDate) {
      return false
    } else if (targetDate > currentDate) {
      return true
    } else {
      return null
    }
  }

  const calculateAge = (birthdate: string): number | null => {
    // 현재 날짜의 연/월/일만 사용합니다. 시각은 연령 산정에 포함하지 않습니다.
    const currentDate = new Date()

    // 생년월일에서 년도, 월, 일을 추출합니다.
    const year = Number(birthdate.slice(0, 2))
    const month = Number(birthdate.slice(2, 4)) - 1 // 월은 0부터 시작하므로 1을 빼줍니다.
    const day = Number(birthdate.slice(4, 6))

    // 1900년대와 2000년대 출생자를 구분합니다.
    const birthYear = year < 24 ? 2000 + year : 1900 + year

    // 달력상 생일이 아직 오지 않은 경우에만 한 살을 뺍니다.
    // 생일 당일은 만 나이가 증가한 상태로 처리됩니다.
    let age = currentDate.getFullYear() - birthYear
    const birthdayHasNotOccurredThisYear =
      currentDate.getMonth() < month ||
      (currentDate.getMonth() === month && currentDate.getDate() < day)

    if (birthdayHasNotOccurredThisYear) {
      age -= 1
    }

    return age
  }
  const isValidDate = (dateString: string) => {
    // 날짜 형식을 검증하기 위한 정규 표현식
    const datePattern = /^\d{4}-\d{2}-\d{2}$/

    // 정규 표현식과 문자열을 비교하여 검증
    if (!datePattern.test(dateString)) {
      return false
    }

    // 유효한 날짜인지 확인
    const [year, month, day] = dateString.split('-').map(Number)

    if (month < 1 || month > 12) {
      return false // 올바른 월 범위 확인
    }

    const maxDay = new Date(year, month, 0).getDate() // 해당 월의 최대 일 수 계산
    if (day < 1 || day > maxDay) {
      return false // 올바른 일 범위 확인
    }

    return true // 모든 검증 통과
  }

  const isValidDate2 = (dateString: string) => {
    // 날짜 형식을 검증하기 위한 정규 표현식 (YYYYMMDD)
    const datePattern = /^\d{8}$/

    // 정규 표현식과 문자열을 비교하여 검증
    if (!datePattern.test(dateString)) {
      return false
    }

    // 유효한 날짜인지 확인
    const year = parseInt(dateString.substr(0, 4), 10)
    const month = parseInt(dateString.substr(4, 2), 10)
    const day = parseInt(dateString.substr(6, 2), 10)

    if (month < 1 || month > 12) {
      return false // 올바른 월 범위 확인
    }

    const maxDay = new Date(year, month, 0).getDate() // 해당 월의 최대 일 수 계산
    if (day < 1 || day > maxDay) {
      return false // 올바른 일 범위 확인
    }

    return true // 모든 검증 통과
  }

  const formatLicenseType = (type: string): string => {
    switch (type) {
      case '01003':
        return '11'
      case '01001':
        return '12'
      case '01002':
        return '13'
      case '02001':
        return '32'
      case '02002':
        return '33'
      case '02003':
        return '38'
      case '01004':
        return '14'
      case '01005':
        return '15'
      case '01006':
        return '16'
      default:
        return '' // 어떤 경우에도 매칭되지 않으면 빈 문자열 반환
    }
  }

  const formatBirthTime = (time: number): string => {
    const date = new Date(time);
    const year = date.getFullYear().toString().slice(-2); // 연도의 끝 두 자리
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 월
    const day = date.getDate().toString().padStart(2, '0'); // 일

    return `${year}${month}${day}`;
  };

  return {
    formatPhoneNumber,
    formatLicenseType,
    formatDate,
    formatDate2,
    compareWithCurrentTime,
    calculateAge,
    isValidDate,
    isValidDate2,
    getNextDayIfPast,
    formatBirthTime
  }
}
